import React, { useState } from 'react';
function CaloriesTable({ caloriesBurned, bmr, maintain, mildLoss, lose, extremeLoss, mildGain, gain, extremeGain }) {
  return (
    <table >
      <thead>
        <tr>
          <th >État de gestion du poids</th>
          <th >Calories (par jour)</th>
        </tr>
      </thead>
      <tbody>
        <tr >
          <td>Maintien du poids</td>
          <td>{maintain} </td>
        </tr>
        <tr >
          <td>Perte de poids légère (0,25 kg/semaine)</td>
          <td>{mildLoss} </td>
        </tr>
        <tr >
          <td>Perte de poids (0,5 kg/semaine)</td>
          <td>{lose} </td>
        </tr>
        <tr >
          <td>Perte de poids extrême (1 kg/semaine)</td>
          <td>{extremeLoss} </td>
        </tr>
        <tr >
          <td>Gain de poids léger (0,25 kg/semaine)
          </td>
          <td>{mildGain} </td>
        </tr>
        <tr >
          <td>Gain de poids (0,5 kg/semaine)</td>
          <td>{gain} </td>
        </tr>
        <tr >
          <td>Gain de poids rapide (1 kg/semaine)</td>
          <td>{extremeGain} </td>
        </tr>
        <tr >
          <td colSpan="2">Total des calories consommées/brûlées: {caloriesBurned} (par jour) </td>
        </tr>
        <tr  >
          <td colSpan="2">Taux métabolique basal BMR est: {bmr} </td>
        </tr>
      </tbody>
    </table>
  );
}
export default CaloriesTable;